import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const ProfileContext = createContext();

export const useProfile = () => {
  const context = useContext(ProfileContext);
  if (!context) {
    throw new Error('useProfile must be used within a ProfileProvider');
  }
  return context;
};

export const ProfileProvider = ({ children }) => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/user-profile');
      setProfileData(response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch profile:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async (updatedData) => {
    try {
      setLoading(true);
      const response = await api.put('/api/user-profile', updatedData);
      // Update local state with new data
      await fetchProfile();
      return response.data;
    } catch (error) {
      console.error('Failed to update profile:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const value = {
    profileData,
    loading,
    fetchProfile,
    updateProfile,
    setProfileData
  };

  return (
    <ProfileContext.Provider value={value}>
      {children}
    </ProfileContext.Provider>
  );
};

export default ProfileContext; 